var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFileSvg(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "square",
    strokeWidth: 2,
    fill: "none",
    stroke: "#212121",
    className: "file-svg_svg__nc-icon-wrapper",
    strokeMiterlimit: 10
  }, /*#__PURE__*/React.createElement("path", {
    "data-cap": "butt",
    strokeLinecap: "butt",
    d: "M20 1v8h8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28 13V9l-8-8H4v12M4 27v4h24v-4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.3 21.3c0 .4-.1.7-.3.9s-.4.5-.8.6-.7.2-1.2.2c-.4 0-.7 0-1-.1s-.5-.1-.8-.3v-1.4c.3.2.6.3.9.4s.6.1.9.1c.2 0 .4 0 .5-.1s.2-.2.2-.3c0-.1 0-.1-.1-.2l-.2-.2c-.1-.1-.3-.2-.8-.4-.4-.2-.7-.3-.8-.5s-.3-.3-.4-.5-.1-.4-.1-.7c0-.5.2-.9.6-1.2s.9-.4 1.6-.4c.6 0 1.2.1 1.8.4l-.5 1.2c-.5-.2-1-.4-1.4-.4-.2 0-.3 0-.4.1s-.1.2-.1.3c0 .1.1.2.2.3s.4.2.9.5c.5.2.8.5 1 .7s.3.6.3 1zM16.4 17.3h1.7L16.3 23h-1.8l-1.9-5.7h1.7l.8 2.9c.2.6.2 1.1.3 1.3 0-.2.1-.4.1-.7s.1-.5.1-.6l.8-2.9zM21 19.7h2.5v3.1c-.7.2-1.4.3-2.2.3-.9 0-1.6-.3-2-.8s-.7-1.2-.7-2.2c0-.9.3-1.6.8-2.2s1.3-.8 2.2-.8c.4 0 .7 0 1 .1s.6.2.8.3l-.5 1.2c-.4-.2-.9-.3-1.4-.3-.5 0-.8.1-1 .4s-.4.7-.4 1.3c0 .5.1.9.3 1.2s.5.4 1 .4c.2 0 .4 0 .6-.1v-.9h-1v-1z",
    fill: "#212121",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 13h30v14H1z"
  }))));
}
export default SvgFileSvg;